import { pushTo } from '@app/core/routing';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { useComposition } from '@app/modules/compose/screens/view/hooks/useComposition';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { usePlatformMediaLimitsIndications } from '@app/modules/social-export/hooks/usePlatformMediaLimitsIndications';
import { PublishPlatformDropdown } from '@app/modules/social-export/publish';
import { useCompositionPublishableRenderedEdits } from './useCompositionPublishableRenderedEdits';

/**
 * "Publicar en" menu for compositions; navigates to the composition upload wizard per platform.
 */
export function ComposeSocialExportPublishDropdown() {
  const { composition } = useComposition();
  const stationId = composition.stationId ?? undefined;
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(stationId);
  const { hasAvailableSources } = useCompositionPublishableRenderedEdits(composition.id);
  // Composition edit duration is not available on list DTOs; soft tips still use the station tier.
  const indicationByPlatformId = usePlatformMediaLimitsIndications(
    stationId,
    availablePlatforms,
    undefined,
  );

  const handlePlatformSelect = (platformId: string) => {
    const platform = availablePlatforms.find(
      (p: SocialPlatform) => p.id.toUpperCase() === platformId.toUpperCase(),
    );
    if (platform) {
      pushTo(composeRouteGenerator.upload(composition.id, platform.id));
    }
  };

  return (
    <PublishPlatformDropdown
      platforms={availablePlatforms}
      disabled={!hasAvailableSources}
      indicationByPlatformId={indicationByPlatformId}
      onSelectPlatform={handlePlatformSelect}
    />
  );
}
